import { render, staticRenderFns } from "./FlashSide.vue?vue&type=template&id=4fe2afd7"
import script from "./FlashSide.vue?vue&type=script&lang=js"
export * from "./FlashSide.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports